import instance from './instance';

export const fetchCurrentVersion = () => instance.get('/application/current_version');
